export default __webpack_public_path__ + "static/media/fish necklace multi.e8a393e7.png";